import type { SVGProps } from "react";

export function DiagonalArrowIcon({
  props,
  fillColor = "white",
  width = 11,
  height = 11,
}: {
  props?: SVGProps<SVGSVGElement>;
  fillColor?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 11 11"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.14232 2.06263L4.25421 2.0625L4.25425 0.9375L10.0628 0.9377L10.0628 6.72149L8.93776 6.72148L8.93778 2.85816L0.898026 10.8978L0.102539 10.1022L8.14232 2.06263Z"
        fill={fillColor}
      />
    </svg>
  );
}
